module.exports = __webpack_public_path__ + "img/excel-white.b81930bb.svg";